import { App, Button, Space, Typography } from 'antd';
import Countdown from 'react-countdown';
import { strings } from '../../lang';

const { Text } = Typography;

type PowerHourTimerProps = {
  endTime: Date;
  isPowerHourBar?: boolean;
};

export const PowerHourTimer = ({ endTime, isPowerHourBar }: PowerHourTimerProps) => {
  const { notification } = App.useApp();

  const openPowerHourNotification = () => {
    notification.open({
      message: strings.powerHour.powerHourEnded,
      btn: (
        <Button type="primary" onClick={() => window.open('/profile', '_blank')}>
          {strings.powerHour.viewResults}
        </Button>
      ),
      duration: 0, // notification stays until closed
    });
  };

  return (
    <Space>
      <Text style={{ color: isPowerHourBar ? 'var(--color-black)' : 'inherit' }}>
        {new Date() < endTime ? (
          <>
            {strings.powerHour.remainingTime}{' '}
            <Countdown
              date={endTime}
              renderer={({ hours, minutes, seconds, completed }) =>
                completed ? (
                  <>{openPowerHourNotification()}</>
                ) : (
                  <span>
                    {hours > 0 ? `${hours.toString().padStart(2, '0')}:` : ''}
                    {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')} Minuten
                  </span>
                )
              }
            />
          </>
        ) : (
          <span>{strings.powerHour.powerHourComplete}</span>
        )}
      </Text>
    </Space>
  );
};
